parseInterfaceTypeExtension